import React, { Component } from 'react';
import { ElementsConsumer, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import modal from '../../../css/module/modal.css';
import CheckoutForm from './CheckoutForm';

class AddCardModal extends Component {
  content = () => {
    const { onCardUpdated } = this.props;

    const stripePromise = loadStripe(this.props.stripeKey);

    return (
      //
      // https://stripe.com/docs/stripe-js/react#elements-consumer
      //
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => (
            <CheckoutForm
              elements={elements}
              stripe={stripe}
              onCardUpdated={onCardUpdated}
            />
          )}
        </ElementsConsumer>
      </Elements>
    );
  };

  render() {
    return (
      <div
        style={{ maxWidth: '600px', padding: '10px 30px 30px', color: '#000' }}
        className={modal.container}
      >
        <h1>Add card details</h1>
        {this.content()}
        <p className="margin-top-30">
          By adding your card, you authorize TMD Technology Limited (that's us{' '}
          <img
            src="/img/smile.png"
            style={{ width: '15px', marginTop: '-2px' }}
          />
          ) to take monthly payments in respect of your Trevor.io subscription.
          You can cancel anytime.
        </p>
      </div>
    );
  }
}

export default AddCardModal;
